import styled from 'styled-components';

export const Container = styled.div`
  input:checked + label {
    .icon-wrapper {
      border: 1px solid #304ffe;
      box-shadow: none;
      span {
        position: absolute;
        bottom: -13px;
      }
    }
  }
  .icon-wrapper {
    & img {
      max-width: 32px;
    }
  }
`;

export const IconWrapper = styled.div`
  width: 56px;
  height: 56px;
  box-shadow: 0 2px 4px 0 rgba(23, 25, 26, 0.08);
  border-radius: 50%;
`;
